import { DesktopAudioArtifactRef } from "@/modules/electron/types";
import { WebAudioArtifactRef } from "@/modules/audio-recording/web-artifacts";

export type RendererAudioUploadSource = WebAudioArtifactRef | DesktopAudioArtifactRef;

export const isDesktopAudioArtifactRef = (
  source: RendererAudioUploadSource
): source is DesktopAudioArtifactRef => {
  return (
    typeof source === "object" && source !== null && "artifactId" in source && "filePath" in source
  );
};

export const isWebAudioArtifactRef = (
  source: RendererAudioUploadSource
): source is WebAudioArtifactRef => {
  return (
    typeof source === "object" &&
    source !== null &&
    "artifactId" in source &&
    "key" in source &&
    !("filePath" in source)
  );
};
